import request from '@/utils/request'
const baseURL = process.env.VUE_APP_BASE_API

export const CONFIGAPI = {
  // 获取问题类型列表
  getIssuesType: (params: any) => {
    return request({
      url: baseURL + 'config/assistant/issue_type/list',
      method: 'get',
      params
    })
  },
  // 更新问题类型是否开启自动填充功能
  changeSwithcValue: (params: any) => {
    return request({
      url: baseURL + 'config/assistant/issue_type/updateSwitchValue',
      method: 'post',
      params
    })
  },
  // 新建问题类型
  addIssuesType: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/assistant/issue_type/add',
      method: 'post',
      data,
      params
    })
  },
  // 编辑问题类型
  editIssuesType: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/assistant/issue_type/update',
      method: 'post',
      data,
      params
    })
  },
  // 删除问题类型
  delIssuesType: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/assistant/issue_type/delete',
      method: 'post',
      data,
      params
    })
  },
  // 获取工作日列表
  getWorkDayList: (params: object) => {
    return request({
      url: baseURL + 'config/assistant/workday/list',
      method: 'get',
      params
    })
  },

  // 获取工作日列表
  getCommonTypeList: (params: object) => {
    return request({
      url: baseURL + 'config/assistant/common_type/list',
      method: 'get',
      params
    })
  },

  // 编辑工作日信息
  editWrokday: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/assistant/workday/update',
      method: 'post',
      data,
      params
    })
  },
  // 获取团队信息列表
  getTeamInfoList: (params: object) => {
    return request({
      url: baseURL + 'config/assistant/teaminfo/list',
      method: 'get',
      params
    })
  },

  // 新建团队信息
  addTeamInfo: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/assistant/teaminfo/add',
      method: 'post',
      data,
      params
    })
  },
  // 编辑团队信息
  editTeamInfo: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/assistant/teaminfo/update',
      method: 'post',
      data,
      params
    })
  },
  // 删除团队信息
  delTeamInfo: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/assistant/teaminfo/delete',
      method: 'post',
      data,
      params
    })
  },

  // 新建通用类型
  addCommonType: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/assistant/common_type/add',
      method: 'post',
      data,
      params
    })
  },
  // 编辑通用类型
  editCommonType: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/assistant/common_type/update',
      method: 'post',
      data,
      params
    })
  },

  // 删除团队信息
  delCommonType: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/assistant/common_type/delete',
      method: 'post',
      data,
      params
    })
  },
  // 获取笔记本型号
  getComputerType: (params: object) => {
    return request({
      url: baseURL + 'config/assistant/computer_type/list',
      method: 'get',
      params
    })
  },
  // 新建笔记本型号
  addComputerType: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/assistant/computer_type/add',
      method: 'post',
      data,
      params
    })
  },
  // 编辑笔记本型号
  editComputerType: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/assistant/computer_type/update',
      method: 'post',
      data,
      params
    })
  },
  // 删除笔记本型号
  delComputerType: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/assistant/computer_type/delete',
      method: 'post',
      data,
      params
    })
  },

  // 获取地区列表数据
  getAreaData: (params: object) => {
    return request({
      url: baseURL + 'config/assistant/place/list',
      method: 'get',
      params
    })
  },
  // 新建地区
  addArea: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/assistant/place/add',
      method: 'post',
      data,
      params
    })
  },

  // 编辑地区
  editArea: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/assistant/place/update',
      method: 'post',
      data,
      params
    })
  },
  // 删除地区
  delArea: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/assistant/place/delete',
      method: 'post',
      data,
      params
    })
  },

  // 获取位置信息
  getLocation: (params: object) => {
    return request({
      url: baseURL + 'config/assistant/location/tree',
      method: 'get',
      params
    })
  },
  // 获取lmp位置信息
  getLmpLocation: (params: object) => {
    return request({
      url: baseURL + 'config/assistant/lmp/location/list',
      method: 'get',
      params
    })
  },
  // 获取基地列表数据
  getBuildingData: (params: object) => {
    return request({
      url: baseURL + 'config/assistant/building/list',
      method: 'get',
      params
    })
  },


  // 新建基地
  addBuilding: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/assistant/building/add',
      method: 'post',
      data,
      params
    })
  },
  // 编辑基地
  editBuilding: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/assistant/building/update',
      method: 'post',
      data,
      params
    })
  },
  // 删除基地
  delBuilding: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/assistant/building/delete',
      method: 'post',
      data,
      params
    })
  },
  // 获取基地解决方案
  getStrategyData: (params: object) => {
    return request({
      url: baseURL + 'config/assistant/strategy/list',
      method: 'get',
      params
    })
  },
  // 新建基地解决方案
  addStrategy: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/assistant/strategy/add',
      method: 'post',
      data,
      params
    })
  },
  // 编辑基地解决方案
  editStrategy: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/assistant/strategy/update',
      method: 'post',
      data,
      params
    })
  },
  // 删除基地解决方案
  delStrategy: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/assistant/strategy/delete',
      method: 'post',
      data,
      params
    })
  },
  // 获取群组列表数据
  getGroupData: (params: object) => {
    return request({
      url: baseURL + 'config/users/group/list',
      method: 'get',
      params
    })
  },
  // 新建群组
  addGroup: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/users/group/add',
      method: 'post',
      data,
      params
    })
  },
  // 编辑群组
  editGroup: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/users/group/update',
      method: 'post',
      data,
      params
    })
  },
  // 删除群组
  delGroup: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/users/group/delete',
      method: 'post',
      data,
      params
    })
  },
  // 获取基地树状结构
  getBuildingTree: (params: object) => {
    return request({
      url: baseURL + 'config/assistant/building/tree',
      method: 'get',
      params
    })
  },
  // 获取用户信息（用户关联用户时筛选）
  getUsersData: (params: object) => {
    return request({
      url: baseURL + 'ticket/user/info',
      method: 'get',
      params
    })
  },
  // 测试知音楼机器人是否有效
  testGroupRobot: (data: object, params: any) => {
    return request({
      url: baseURL + 'config/users/group/send_test_message',
      method: 'post',
      data,
      params
    })
  },
  // 获取工单受理人列表
  getHandlerList: (params: any) => {
    return request({
      url: baseURL + 'config/users/list',
      method: 'get',
      params
    })
  },
  // 所有配置项操作日志
  getConfigLog: (params: object) => {
    return request({
      url: baseURL + 'config/assistant/log',
      method: 'get',
      params
    })
  },
  // 获取js-config
  getJsConfig: (data: any) => {
    return request({
      url: baseURL + 'ticket/getJsConfig',
      method: 'post',
      data
    })
  },
  // 获取全局配置
  getGlobalConfig: (params: any) => {
    return request({
      url: baseURL + 'config/users/global',
      method: 'get',
      params
    })
  },
  // 修改全局配置
  updateGlobalConfig: (data: any, params: any, id: number) => {
    return request({
      url: baseURL + 'config/users/global/' + id,
      method: 'post',
      data,
      params
    })
  }
}
